export const fscDate = {
  computed: {
    ysyTypeInPickerOptions() {
      var _this = this
      return {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const todayDate = new Date().toLocaleDateString()
            var dateArr = _this.ysyNowDate(todayDate)
            const start = new Date(
              dateArr[0],
              dateArr[1] - 1,
              dateArr[2],
              0,
              0,
              0
            )
            const end = new Date(
              dateArr[0],
              dateArr[1] - 1,
              dateArr[2],
              23,
              59,
              59
            )
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '昨天',
          onClick(picker) {
            const dd = new Date()
            dd.setDate(dd.getDate() - 1)
            var yesterDate = dd.toLocaleDateString()
            var dateArr = _this.ysyNowDate(yesterDate)
            const start = new Date(
              dateArr[0],
              dateArr[1] - 1,
              dateArr[2],
              0,
              0,
              0
            )
            const end = new Date(
              dateArr[0],
              dateArr[1] - 1,
              dateArr[2],
              23,
              59,
              59
            )
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '本周',
          onClick(picker) {
            var now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth()
            const day = now.getDate()
            const week = now.getDay()

            let start = new Date(year, month, day - week + 1, 0, 0, 0)
            let end = new Date(year, month, day - week + 7, 23, 59, 59)

            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '上周',
          onClick(picker) {
            var dateS = _this.ysyGetWeek(-1, 0).split('-')
            var dateE = _this.ysyGetWeek(-1, 1).split('-')

            let start = new Date(dateS[0], dateS[1] - 1, dateS[2], 0, 0, 0)
            let end = new Date(dateE[0], dateE[1] - 1, dateE[2], 23, 59, 59)

            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '本月',
          onClick(picker) {
            var str = _this.ysyGetCurrentDate()

            var arr = _this.ysyGetfirstDateAndlastDate(str)

            var arrS = arr[0].split('-')
            var arrE = arr[1].split('-')

            var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0)
            var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59)

            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '上个月',
          onClick(picker) {
            var str = _this.ysyFromLastMonth()

            var arr = _this.ysyGetfirstDateAndlastDate(str)

            var arrS = arr[0].split('-')
            var arrE = arr[1].split('-')

            var start = new Date(arrS[0], arrS[1] - 1, arrS[2], 0, 0, 0)
            var end = new Date(arrE[0], arrE[1] - 1, arrE[2], 23, 59, 59)

            picker.$emit('pick', [start, end])
          }
        }
        ]
      }
    }
  },
  methods: {
    ysyNowDate(date) {
      return date.split('/')
    },
    ysyGetWeek(n, type) {
      // 周
      let now = new Date()
      let day = now.getDay() // 返回星期几的某一天;
      if (!type) {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day
          now.setDate(now.getDate() + dayNumber + 1)
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1
          now.setDate(now.getDate() - dayNumber - 7)
        } else {
          let dayNumber = day === 0 ? 6 : day - 1
          now.setDate(now.getDate() - dayNumber)
        }
      } else {
        if (n === 1) {
          let dayNumber = day === 0 ? 0 : 7 - day
          now.setDate(now.getDate() + dayNumber + 1 + 6) // 在周开始的日期上+6天=周结束
        } else if (n === -1) {
          let dayNumber = day === 0 ? 6 : day - 1
          now.setDate(now.getDate() - dayNumber - 7 + 6)
        } else {
          let dayNumber = day === 0 ? 0 : 7 - day
          now.setDate(now.getDate() + dayNumber)
        }
      }
      let date = now.getDate()
      let month = now.getMonth() + 1

      let s =
        now.getFullYear() +
        '-' +
        (month < 10 ? '0' + month : month) +
        '-' +
        (date < 10 ? '0' + date : date)
      return s
    },
    ysyGetfirstDateAndlastDate(dateC) {
      var dateStr = dateC
      var date = new Date(dateStr)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (month > 12) {
        month = 1
        year++
      }
      if (month < 10) {
        month = '0' + month
      }
      var monthLastDay = new Date(year, month, 0).getDate()
      var firstDate = year + '-' + month + '-' + '01'
      var lastDate = year + '-' + month + '-' + monthLastDay
      return [firstDate, lastDate]
    },
    ysyGetCurrentDate() {
      var date = new Date()
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    ysyFromLastMonth() {
      var date = new Date()
      var lastMonthDate = ''
      // 获取当前几号，如果小于10则补0
      var day = date.getDate()
      if (day < 10) {
        day = '0' + day
      }
      var month = date.getMonth()
      var year = date.getFullYear()
      // 上个月小于1则证明跨年，年份减1
      if (month < 1) {
        lastMonthDate = year - 1 + '-12-' + day
      } else {
        // 月份小于10则补0
        if (month < 10) {
          month = '0' + month
        }
        lastMonthDate = year + '-' + month + '-' + day
      }
      return lastMonthDate
    },
    ysyCurMonth() {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const timeZoneOffset = 8 * 60 * 60 * 1000; // 东八区时区偏移量（单位：毫秒）
      const startDate = new Date(start.getTime() + timeZoneOffset);
      const endDate = new Date(end.getTime() + timeZoneOffset);

      // 将日期格式化为 "yyyy-MM-dd" 格式的字符串
      function formatDate(date) {
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // 月份需要加1因为从0开始
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
      }

      return [formatDate(startDate), formatDate(endDate)];
    },
    ysyCurMonthForHuamn(date) {
      let start = date[0].split('-');
      let end = date[1].split('-');
      return `${start[0]}年${start[1]}月${start[2]}日 - ${end[0]}年${end[1]}月${end[2]}日`
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./static/mixins/fastChooseDate.js
// module id = zESM
// module chunks = 29